var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPcoWorkflow = function SvgPcoWorkflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M37 36.548a7.653 7.653 0 1 0 0-15.306 7.653 7.653 0 0 0 0 15.306m0-2a5.653 5.653 0 1 0 0-11.306 5.653 5.653 0 0 0 0 11.306M47.714 48.793c0 1.53-4.797 4.591-10.714 4.591s-10.714-3.06-10.714-4.592c0-5.917 4.797-10.714 10.714-10.714s10.714 4.797 10.714 10.714m-2.2-.105q.128-.12.195-.2a8.714 8.714 0 0 0-17.418 0q.066.08.196.2c.365.338.975.763 1.822 1.18 1.685.832 4.063 1.516 6.691 1.516s5.006-.684 6.691-1.515c.847-.418 1.457-.843 1.822-1.18",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 18.802a2 2 0 0 0-2 2v34.282a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h50a2 2 0 0 0 2-2V26.802a2 2 0 0 0-2-2h-1v-1a2 2 0 0 0-2-2h-1v-1a2 2 0 0 0-2-2zm50 38.282a2 2 0 0 0 2-2V23.802h1v34.282H15v-1zm3 3a2 2 0 0 0 2-2V26.802h1v34.282H18v-1zm-3-39.282H12v34.282h50z",
    clipRule: "evenodd"
  })));
};
export default SvgPcoWorkflow;